export default "__VITE_ASSET__BlrqUWsl__"